import { render, staticRenderFns } from "./BranchSchedule.vue?vue&type=template&id=024314bc&scoped=true"
import script from "./BranchSchedule.vue?vue&type=script&lang=js"
export * from "./BranchSchedule.vue?vue&type=script&lang=js"
import style0 from "./BranchSchedule.vue?vue&type=style&index=0&id=024314bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024314bc",
  null
  
)

export default component.exports